/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}
interface IComprobarDocumento {
  tipo: number | null;
  documento: string | undefined;
}

export const comprobarDocumento = async (
  query: IComprobarDocumento
): Promise<any> => {
  try {
    const res = await apiClient.post<ApiResponse<any>>(
      Endpoints.Depo20ComprobarDocumento,
      {
        tipo: 2,
        documento: `${query.documento}`,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
